import userServices from '../../../services/user'
import orgServices from '../../../services/notisphere/organization'
import UserModal from './UserModal'
import ErrorModal from '../../share/ErrorModal'
import DeactivateModal from './DeactivateModal'
import { USER_STATUS, EMAIL_ACTIVITY,EMAIL_STATUS,USERS_STATUS } from '../../../misc/commons'
import {Notisphere_Users_AgGrid, Users_AgGrid, AG_GridCustomizedTableHeaders_Key} from '../../../misc/tableHeaders'
import store from '../../../store'
import _ from 'lodash'

// Add a constant for the default filter flag
const USER_STATUS_DEFAULT_FILTER_KEY = 'notisphere_user_status_default_applied'

export default {
    components: {
        UserModal,
        ErrorModal,
        DeactivateModal
    },
    data() {
        return {
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
                onGridReady: this.onGridReady, // Add this
            },
            total: 0,
            delay: 700,
            clicks: 0,
            timer: null,
            items: [],
            searchQuery: { pageNumber: 1, pageSize: 500, sort: null, colId: null },
            organization_id: null,
            organizations: [],
            user_status: USER_STATUS,
            user_email_status: USERS_STATUS,
            email_status: EMAIL_ACTIVITY,
            status: EMAIL_STATUS,
            userModalKey: 0,
            errorModalKey: 0,
            deactivateModalKey: 0,
            createdEmailTime: null,
            createdEmail: null,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            search: { full_name: null, email: null, organization_name: null, title: null, userSite: null, organization_type: null, status: null, last_logged_in: null, email_activity: null, template_name: null, email_status_date: null },
            globalSearchText: '',
            hasUserModifiedStatusFilter: false, // Add flag to track user modifications
        }
    },
    created() {
        this.rowModelType = 'serverSide'
    },
    beforeMount() {
        if(this.$store.state?.userType === 'PROVIDER' || this.$store.state?.userType === 'SUPPLIER') {
            this.columnDefs = Users_AgGrid
        } else {
            this.columnDefs = Notisphere_Users_AgGrid
        }
    },
    mounted() {
        if (this._isNotisphere) {
            this.fetchOrgMeta()
        }
    },
    computed: {
        showUserAccountDownloadReportBtn() {
            return this._isNotisphere
        },
        currentUserId() {
            return this.$store.state.user.id ? this.$store.state.user.id : -1
        }
    },
    methods: {
        onCompleted(type) {
            if (type.type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            if (type.type == 'INSERT') {
                this._showToast('Added successfully!')
            }
            this.createdEmailTime = type.emailTime
            this.createdEmail=type.emailId
            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
        },
        addMoreClick() {
            this.userModalKey += 1
            this.$nextTick(() => {
                this.$refs.userModal.forceRerenderInsert(this.organization_id)
            })
        },
        doubleClick(event){
            this.clicks++
            if(this.clicks === 1) {
                var self = this
                this.timer = setTimeout(function() {
                    self.clicks = 0
                }, this.delay)
            } else{
                clearTimeout(this.timer)
                this.updateUser(event)
                this.clicks = 0
            }
        },
        updateUser(payload, e = null) {
            this.userModalKey += 1
            this.$nextTick(() => {
                this.$refs.userModal.forceRerenderUpdate(payload.id, payload.organization_id,payload.organization_type,payload.status, payload.oldStatus, payload.email)
            })
            if (e) {
                e.stopPropagation()
            }
        },
        ViewErrorModal(item) {
            this.errorModalKey += 1
            this.$nextTick(() => {
                this.$refs.errorModal.forceRerenderView(
                    item
                )
            })
        },
        fetchDelay() {
            this.$refs.table.fetchDelay()
        },
        fetchOrgMeta() {
            orgServices.findMeta().then(resp => {
                if (!resp.error) {
                    this.organizations = resp.data.d
                }
            })
        },
        sendResetPasswordEmail(id, e) {
            userServices.sendResetPasswordEmail(id).then(resp => {
                if (!resp.error) {
                    this._showToast('Email sent successfully!')
                    this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                }
            })
            e.stopPropagation()
        },
        resendVerificationEmail(id, e) {
            userServices.resendVerificationEmail(id).then(resp => {
                if (!resp.error) {
                    this._showToast('Email sent successfully!')
                    this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                }
            })
            e.stopPropagation()
        },
        updateStatus(item, e) {
            var new_status = null
            switch (item.status) {
            case 'SSO':
                new_status = 'DEACTIVATED'
                break
            case 'VERIFIED':
                new_status = 'DEACTIVATED'
                break
            case 'DEACTIVATED':
                new_status = 'VERIFIED'
                break
            }
            if (new_status) {
                userServices.updateStatus({
                    id: item.id,
                    status: new_status
                }).then(resp => {
                    if (!resp.error) {
                        this.onCompleted('UPDATE')
                    }else{
                        if (resp.data.c == 'err_deactivate_provider_admin') {
                            this.deactivateModalKey += 1
                            this.$nextTick(() => {
                                this.$refs.deactivateModal.forceRerenderView({
                                    title: 'Deactivate User',
                                    message: 'This is the last user on this account, are you sure you want to deactivate the user?',
                                    btnCancel: 'Cancel',
                                    btnConfirm: 'Deactivate',
                                    id: item.id,
                                })
                            })
                        }
                    }
                })
            }
            e.stopPropagation()
        },
        deleteUser(item, e) {
            this._showConfirm('You are about to delete this user, this cannot be undone.').then(confirm => {
                if (confirm) {
                    userServices.deleteUser(item.id).then(resp => {
                        if (!resp.error) {
                            this.onCompleted('UPDATE')
                        }
                    })
                }
            })
            e.stopPropagation()
        },
        userForceDeactivate(id){
            userServices.updateStatus({
                id: id,
                status: 'DEACTIVATED',
                forceDeactivate: true
            }).then(resp => {
                if (!resp.error) {
                    this.onCompleted('UPDATE')
                }
            })
        },
        btnUserAccountReportXLSXClick() {
            userServices.downloadUserAccountXLSXReport().then()
        },
        //  ------------------------------ Ag-Grid Table methods ---------------------------------------
        onGridReady(params) {
            this.gridApi = params.api
            this.columnApi = params.columnApi
            // Don't apply default filter here, let fetchData handle it
        },
        applyDefaultStatusFilter() {
            const defaultFilterApplied = localStorage.getItem(USER_STATUS_DEFAULT_FILTER_KEY)

            if (!defaultFilterApplied || defaultFilterApplied === 'false') {
                // Get current filter model
                const currentFilterModel = this.gridApi.getFilterModel() || {}

                // Apply default filter to show 'SSO', 'NONVERIFIED', 'VERIFIED', 'VERIFICATION' statuses
                currentFilterModel.status = {
                    filterType: 'set',
                    values: ['SSO', 'NONVERIFIED', 'VERIFIED', 'VERIFICATION']
                }

                this.gridApi.setFilterModel(currentFilterModel)

                // Mark that default filter has been applied
                localStorage.setItem(USER_STATUS_DEFAULT_FILTER_KEY, 'true')
                this.hasUserModifiedStatusFilter = false
            }
        },
        isStatusFilterModified(filterModel) {
            const currentStatusFilter = filterModel?.status?.values
            const defaultStatusFilter = ['SSO', 'NONVERIFIED', 'VERIFIED', 'VERIFICATION']

            if (!currentStatusFilter && !this.hasUserModifiedStatusFilter) {
                return false
            }

            if (!currentStatusFilter || currentStatusFilter.length !== defaultStatusFilter.length) {
                return true
            }

            return !currentStatusFilter.every(status => defaultStatusFilter.includes(status))
        },
        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Notisphere_Login?.Users_Headers
            if (columnState) {
                const organizationNameCol = columnState.find(col => col.colId === 'organization_name')
                const organizationTypeCol = columnState.find(col => col.colId === 'organization_type')

                if (organizationNameCol) {
                    organizationNameCol.hide = this.$store.state?.userType === 'PROVIDER' || this.$store.state?.userType === 'SUPPLIER'
                }
                if (organizationTypeCol) {
                    organizationTypeCol.hide = this.$store.state?.userType === 'PROVIDER' || this.$store.state?.userType === 'SUPPLIER'
                }

                const actionCol = columnState.find(col => col.colId === 'actions')
                columnState = columnState.filter(col => col.colId !== 'actions')
                if (actionCol) {
                    columnState.push(actionCol)
                }
                params.columnApi.applyColumnState({ state: columnState, applyOrder: true })
            }
            // Don't apply default status filter here, let setFilterModel handle it
        },
        setFilterModel(params) {
            const userId = this.$store.state.user.id
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == userId)[0]
            var filterModel = tableState?.Notisphere_Login?.Users_Filter

            if (filterModel) {
                // Check if user has modified status filter before
                const defaultFilterApplied = localStorage.getItem(USER_STATUS_DEFAULT_FILTER_KEY)
                const hasStatusFilter = filterModel.status && filterModel.status.values && filterModel.status.values.length > 0

                if (hasStatusFilter) {
                    // User has a saved status filter, mark as modified
                    this.hasUserModifiedStatusFilter = true
                    localStorage.setItem(USER_STATUS_DEFAULT_FILTER_KEY, 'user_modified')
                    params.api.setFilterModel(filterModel)
                } else if (!defaultFilterApplied || defaultFilterApplied === 'false') {
                    // No saved status filter and default not applied yet, apply default
                    const modifiedFilterModel = { ...filterModel }
                    modifiedFilterModel.status = {
                        filterType: 'set',
                        values: ['SSO', 'NONVERIFIED', 'VERIFIED', 'VERIFICATION']
                    }
                    params.api.setFilterModel(modifiedFilterModel)
                    localStorage.setItem(USER_STATUS_DEFAULT_FILTER_KEY, 'true')
                    this.hasUserModifiedStatusFilter = false
                } else {
                    // Apply saved filters without status filter
                    params.api.setFilterModel(filterModel)
                }
            } else {
                // No saved filters, apply default status filter if not applied yet
                const defaultFilterApplied = localStorage.getItem(USER_STATUS_DEFAULT_FILTER_KEY)
                if (!defaultFilterApplied || defaultFilterApplied === 'false') {
                    params.api.setFilterModel({
                        status: {
                            filterType: 'set',
                            values: ['SSO', 'NONVERIFIED', 'VERIFIED', 'VERIFICATION']
                        }
                    })
                    localStorage.setItem(USER_STATUS_DEFAULT_FILTER_KEY, 'true')
                    this.hasUserModifiedStatusFilter = false
                }
            }
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onFilterChanged(event) {
            // Check if user modified the status filter
            const filterModel = event.api.getFilterModel()
            if (this.isStatusFilterModified(filterModel)) {
                this.hasUserModifiedStatusFilter = true
                // Update localStorage to prevent future default filter applications
                localStorage.setItem(USER_STATUS_DEFAULT_FILTER_KEY, 'user_modified')
            }

            // Save the current filter state including status filter
            this.saveFilterState(event)
            this.table_Connection_Data.Notisphere_Login.Users_Filter = event.api.getFilterModel()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        saveFilterState(params) {
            const userId = this.$store.state.user.id
            const filterModel = params.api.getFilterModel()

            // Find or create user's table state
            let tableStates = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key)) || []
            let userTableState = tableStates.find(s => s.userId === userId)

            if (!userTableState) {
                userTableState = { userId: userId, Notisphere_Login: {} }
                tableStates.push(userTableState)
            }

            if (!userTableState.Notisphere_Login) {
                userTableState.Notisphere_Login = {}
            }

            // Save the filter model
            userTableState.Notisphere_Login.Users_Filter = filterModel

            // Update localStorage
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(tableStates))

            // Update store state
            this.$store.state.CustomizedHeaders = tableStates
        },
        fetchData(params) {
            this.applyState(params)
            this.setFilterModel(params) // Apply saved filters or default filter

            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            const datasource = {
                getRows(params) {
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    that.search.full_name = params.request?.filterModel?.full_name?.filter
                    that.search.email = params.request?.filterModel?.email?.filter
                    that.search.organization_name = params.request?.filterModel?.organization_name?.filter
                    that.search.title = params.request?.filterModel?.title?.filter
                    that.search.userSite = params.request?.filterModel?.userSite?.filter
                    that.search.organization_type = params.request?.filterModel?.organization_type?.filter
                    that.search.status = params.request?.filterModel?.status?.values
                    that.search.last_logged_in = params.request?.filterModel?.last_logged_in?.filter
                    that.search.email_activity = params.request?.filterModel?.email_activity?.filter
                    that.search.template_name = params.request?.filterModel?.template_name?.filter
                    that.search.email_status_date = params.request?.filterModel?.email_status_date?.filter

                    that.search.filterModel = that.gridApi.getFilterModel()
                    userServices.findUser({
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        organizationId: that.organization_id,
                        ...that.search,
                        search: that.globalSearchText
                    }).then(resp => {
                        if (!resp.error) {
                            that.total = resp.data.d.t
                            for(let i = 0 ; i < resp.data.d.c.length ; i++)
                            {
                                if(this.createdEmailTime != null)
                                {
                                    if(this.createdEmail == resp.data.d.c[i].email)
                                    {
                                        resp.data.d.c[i].email_status_date = this.createdEmailTime
                                    }
                                }
                                if(resp.data.d.c[i].phone_number != null || resp.data.d.c[i].phone_number != undefined)
                                {
                                    var x = resp.data.d.c[i].phone_number.replace('+1', '').replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                                    resp.data.d.c[i].phone_number = (x[1] ? x[1] + '-' : '') + x[2] + (x[3] ? '-' + x[3] : '')
                                }
                                if(resp.data.d.c[i].email_status_date != null && resp.data.d.c[i].email_status_date != undefined)
                                {
                                    resp.data.d.c[i].email_status_date = new Date(resp.data.d.c[i].email_status_date).toLocaleString()
                                }
                            }
                            return resp.data.d.c
                        }
                    }).then(response => {
                        params.successCallback(response)
                    }).catch(error => {
                        console.error(error)
                        params.failCallback()
                    })
                }
            }
            // register datasource with the grid
            params.api.setServerSideDatasource(datasource)
        },
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email
                    const query_param = {
                        ...that.searchQuery,
                        sortField: that.searchQuery.colId,
                        sortDirection: that.searchQuery.sort,
                        organizationId: that.organization_id,
                        search: that.globalSearchText,
                        email: email,
                        filterModel: params.api.getFilterModel(),
                    }
                    const resp = await userServices.downloadAgGridUserAccountXLSXReport(query_param)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login.Users_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        resetStatusFilterDefault() {
            localStorage.setItem(USER_STATUS_DEFAULT_FILTER_KEY, 'false')
            this.hasUserModifiedStatusFilter = false
            this.applyDefaultStatusFilter()
        },
        onCellClicked(params) {
            if(params.column.colId === 'actions') {
                if(params.event.target.dataset.action === 'edit') {
                    this.updateUser(params.data, params.event)
                }
                if(params.event.target.dataset.action === 'reset-pwd') {
                    this.sendResetPasswordEmail(params.data.id, params.event)
                }
                if(params.event.target.dataset.action === 'resend-verification') {
                    this.resendVerificationEmail(params.data.id, params.event)
                }
            } else{
                if(params.data.status === 'DELETED') return
                this.updateUser(params.data, params.event)
            }
        },
        debounceInput: _.debounce(function (searchStr) {
            this.searchQuery.pageNumber = 1
            if (searchStr.length > 2) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            } else if (searchStr.length === 0) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }, 500),
        onGlobalSearchChange(inputVal) {
            this.globalSearchText = inputVal
            this.debounceInput(inputVal)
        }
    }
}